import { LoaderFunctionArgs, replace } from 'react-router-dom';

import {
  readAreaParam,
  readAreaUnitParam,
  readPlanParam,
  readPlanetImageryParam,
  readUserSeatsParam,
} from '../../../shared/helpers/functions/navigation';
import {
  isPlanParamsValid,
  isPlanValueValid,
} from '../../../shared/helpers/functions/plans';
import Page from '../pages';

/**
 * Checks that query-string parameters for the checkout flow are valid.
 * If they are missing or invalid a redirect to the Not-Found page is returned.
 */
export function checkoutLoader({ request }: LoaderFunctionArgs) {
  const { searchParams } = new URL(request.url);

  const plan = readPlanParam(searchParams);
  const planParams = {
    areaUnit: readAreaUnitParam(searchParams),
    area: readAreaParam(searchParams),
    userSeats: readUserSeatsParam(searchParams),
    planetImagery: readPlanetImageryParam(searchParams),
  };

  if (!isPlanValueValid(plan) || !isPlanParamsValid(plan, planParams)) {
    return replace(Page.notFound);
  }

  return null;
}
